module.exports = __webpack_public_path__ + "img/BACKGROUND-GOLD-nogutter.26dbd295.jpg";